import { render } from "./SelectTheam.vue?vue&type=template&id=4a6f305a&scoped=true&ts=true"
import script from "./SelectTheam.vue?vue&type=script&lang=ts"
export * from "./SelectTheam.vue?vue&type=script&lang=ts"

import "./SelectTheam.vue?vue&type=style&index=0&id=4a6f305a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a6f305a"]])

export default __exports__